const collapsibles = document.querySelectorAll(".collapsible-header");
const onlyExpandOne = true;
let lastActiveCollapsibleBody = null;

function expand(el) {
  if (
    onlyExpandOne &&
    lastActiveCollapsibleBody
  ) {
    unexpand(lastActiveCollapsibleBody);
  }
  el.style.maxHeight = el.scrollHeight + 30 + "px";
  el.classList.add("active");
  lastActiveCollapsibleBody = el;
}

function unexpand(el) {
  el.style.maxHeight = null;
  el.classList.remove("active");
  el.parentElement.querySelector('.untoggled').style.display = 'block';
  el.parentElement.querySelector('.toggled').style.display = 'none';
}

collapsibles.forEach((collapsible) => {
  const collapsibleBody = collapsible.nextElementSibling;

  if (collapsibleBody.classList.contains("active")) {
    expand(collapsibleBody);
  }

  collapsible.addEventListener("click", function () {
    if (!!collapsibleBody.style.maxHeight) {
      unexpand(collapsibleBody);
      collapsible.querySelector('.untoggled').style.display = 'block';
      collapsible.querySelector('.toggled').style.display = 'none';
    } else {
      expand(collapsibleBody);
      collapsible.querySelector('.untoggled').style.display = 'none';
      collapsible.querySelector('.toggled').style.display = 'block';
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('cart-drawer');
  const gorgiasChat = document.querySelector('#gorgias-chat-container');
  const klaviyoTeaser = document.querySelector('.kl-teaser-SqrcAR');

  if (!cartDrawer) return;

  const toggleElements = () => {
    const isActive = cartDrawer.classList.contains('active');

    if (gorgiasChat) {
      gorgiasChat.style.display = isActive ? 'none' : '';
    }

    if (klaviyoTeaser) {
      klaviyoTeaser.style.zIndex = isActive ? 1 : '';
      klaviyoTeaser.style.right = isActive ? '-200px' : '';
    }
  };

  // Initial check
  toggleElements();

  // Watch for class changes on cart drawer
  const observer = new MutationObserver(toggleElements);

  observer.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ['class']
  });
});